import styled, { css, keyframes } from 'styled-components';

const COLORS = {
  white: '#ffffff',
  ligthGrey: '#E0E0E0',
  darkGrey: '#858585',
  labelSmall: '##BDBDBD',
  buttonGreen: '#01BEA4',
  disabledGrey: '#E0E0E0',
};

const formWrapperAnimation = keyframes`
  0% { opacity: 0; top: 0px; width: 680px; }
  100% { opacity: 1; top: 0; width: 780px; }
`;

const FormWrapper = styled.div`
  animation: ${formWrapperAnimation} 0.5s 0.3s both;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${COLORS.white};
  border-radius: 20px 20px 0 0;
  font-size: 10px;
  min-height: 420px;
  overflow: hidden;
  padding: 15px 30px 0 224px;
  width: 780px;
  position: relative;

  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 81%,
    rgba(255, 255, 255, 0) 100%
  );

  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=0 ); /* IE6-9 */

  @media (max-width: 720px) {
    width: 100%;
  }

  @media (max-width: 1280px) {
    width: 100%;
    padding: 20px;
  }
`;

const Form = styled.form`
  display: ${({ hidden }) => (hidden ? `none` : `flex`)};
  flex-direction: column;
  width: 100%;
  ${props =>
    !props.show &&
    css`
      display: none;
    `}

  input {
    font-family: 'arial' !important;
    font-size: 17px;
    line-height: 20px;
    font-weight: normal;
  }

  @media (max-width: 1280px) {
    width: 100%;
    padding: 0;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid ${COLORS.ligthGrey};
  margin-bottom: 20px;
  flex-wrap: wrap;

  /* @media (max-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    > div > i {
      margin-left: 0;
      margin-right: 30px;
    }
  } */
`;

const Title = styled.h2`
  font-weight: 700;
  font-size: 2.2em;
  padding: 0;
  margin: 0;
  margin-bottom: 10px;
  white-space: nowrap;
  margin-right: 10px;
`;

const InputColumn = styled.div`
  width: 47%;

  @media (max-width: 720px) {
    width: 90%;
  }
`;

const InputRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  label {
    width: 45%;
  }
`;

const InputContainer = styled.div`
  display: ${props => (props.hidden ? 'none' : 'flex')};
  flex-grow: 2;
  justify-content: space-between;

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: center;
  }
`;

const InternationalText = styled.p`
  font-size: 1.2rem;
`;

const buttonDefaultTheme = css`
  background-color: ${COLORS.white};
  border: 2px solid ${COLORS.buttonGreen};
  color: ${COLORS.buttonGreen};
`;

const buttonDisabledTheme = css`
  background-color: ${COLORS.disabledGrey};
  border: 2px solid ${COLORS.disabledGrey};
  pointer-events: none;
  color: ${COLORS.darkGrey};
`;

const buttonActiveTheme = css`
  background-color: ${COLORS.buttonGreen};
  border: 2px solid ${COLORS.buttonGreen};
  color: ${COLORS.white};
`;

const getButtonTheme = theme => {
  return {
    default: buttonDefaultTheme,
    disabled: buttonDisabledTheme,
    active: buttonActiveTheme,
  }[theme];
};

const BtnContainer = styled.div`
  display: flex;
  margin-top: 17px;
  justify-content: flex-end;
`;

const Button = styled.button`
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.4em;
  font-family: 'Montserrat';
  font-weight: 600;
  margin-left: 17px;
  padding: 14px 0;
  transition: all 0.4s ease-in-out;
  width: 185px;

  ${({ theme }) => getButtonTheme(theme)};
`;

const FieldErrorMessage = styled.span`
  position: relative;
  color: red;
`;

export {
  FormWrapper,
  Form,
  HeaderContainer,
  Title,
  InputContainer,
  InputColumn,
  InputRow,
  BtnContainer,
  Button,
  FieldErrorMessage,
  InternationalText,
};
